import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import { push } from 'react-router-redux';
import FontAwesome from 'react-fontawesome';
import { Row, Col } from 'reactstrap';

/*
Props:

abonado
*/
@connect()
export default class extends React.Component {
  add = abonadoId => this.props.dispatch(push(`/dashboard/abonados/add/${abonadoId}/${this.props.isUser ? 'true' : 'false'}`));
  render() {
    const { abonado, isUser } = this.props;
    let secondaryText = false;
    const primaryText = (
      <Row>
        <Col md="6">{abonado.get('nombre') + ' ' + abonado.get('apellido')}</Col>
        <Col md="5">
          <FontAwesome name="address-card-o" className={abonado.get('documentoValidadoBy') ? 'iconInfo pr-10 blue' : 'iconInfo pr-10'} />
          {abonado.get('documento')}
        </Col>
      </Row>
    );

    if (abonado.getIn(['_reservas', 0]) || abonado.get('_usuarioEmpresa'))
      secondaryText = (
        <Row className="autoHeight">
          {isUser && abonado.getIn(['_usuarioEmpresa', 'reservasConcretadas']) && (
            <Col md="5">
              <FontAwesome name="ticket" className="blue iconInfo" />
              <FontAwesome name="check" className="blue iconInfo pr-10" />
              {abonado.getIn(['_usuarioEmpresa', 'reservasConcretadas'])}
            </Col>
          )}
          {abonado.getIn(['_usuarioEmpresa', 'fechaUltimaReserva']) && (
            <Col md="5">
              <FontAwesome name="ticket" className="iconInfo pr-10" />
              {moment(abonado.getIn(['_usuarioEmpresa', 'fechaUltimaReserva'])).fromNow()}
            </Col>
          )}
          {abonado.getIn(['_usuarioEmpresa', 'fav']) && (
            <Col md="2">
              <FontAwesome name="star" className="iconInfo pr-10" />
            </Col>
          )}
        </Row>
      );

    return (
      <div>
        <MaterialUI.ListItem
          onTouchTap={this.add.bind(this, abonado.get('id'))}
          primaryText={primaryText}
          secondaryText={secondaryText}
          rightIcon={isUser ? <FontAwesome name="mobile" className="mb-20" size="2x" /> : <FontAwesome name="user-o" />}
        />
        <MaterialUI.Divider />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/abonados/components/itemList.js